var map = {
	"./error/404.vue": 545,
	"./index/UserRoleChart.vue": 229,
	"./index/VisitCountChart.vue": 230,
	"./index/index.vue": 546,
	"./layout/AppMain.vue": 231,
	"./layout/Layout.vue": 143,
	"./layout/LayoutSystem.vue": 232,
	"./layout/Levelbar.vue": 547,
	"./layout/LinkBar.vue": 233,
	"./layout/Navbar.vue": 234,
	"./layout/PageView.vue": 548,
	"./layout/Sidebar.vue": 235,
	"./layout/SidebarItem.vue": 236,
	"./layout/TabsView.vue": 237,
	"./layout/auth-user/EditUserData.vue": 238,
	"./login/LoginPage.vue": 549,
	"./main/CommentView.vue": 144,
	"./main/LoginView.vue": 92,
	"./main/PlatformMainPage.vue": 550,
	"./main/RegisterView.vue": 111,
	"./main/TopView.vue": 239,
	"./main/TransmitList.vue": 240,
	"./main/VideoByMeList.vue": 241,
	"./main/VideoList.vue": 242,
	"./main/VideoTransmitView.vue": 145,
	"./main/VideoUploadView.vue": 146,
	"./main/VideoView.vue": 147,
	"./platform/auth-permission/ItemAdd.vue": 243,
	"./platform/auth-permission/ItemEdit.vue": 244,
	"./platform/auth-permission/ItemList.vue": 551,
	"./platform/auth-permission/ItemParticulars.vue": 245,
	"./platform/auth-role/ItemAdd.vue": 246,
	"./platform/auth-role/ItemEdit.vue": 247,
	"./platform/auth-role/ItemList.vue": 552,
	"./platform/auth-role/ItemParticulars.vue": 248,
	"./platform/auth-user/ItemAdd.vue": 249,
	"./platform/auth-user/ItemEdit.vue": 250,
	"./platform/auth-user/ItemList.vue": 553,
	"./platform/auth-user/ItemParticulars.vue": 251,
	"./platform/platform-api-log/ItemList.vue": 554,
	"./platform/platform-api-log/ItemParticulars.vue": 252,
	"./platform/platform-dict/ItemAdd.vue": 253,
	"./platform/platform-dict/ItemEdit.vue": 254,
	"./platform/platform-dict/ItemList.vue": 555,
	"./platform/platform-dict/ItemParticulars.vue": 255,
	"./platformUser/ItemAdd.vue": 256,
	"./platformUser/ItemEdit.vue": 257,
	"./platformUser/ItemList.vue": 556,
	"./platformUser/ItemParticulars.vue": 258,
	"./videoComment/ItemAdd.vue": 259,
	"./videoComment/ItemEdit.vue": 260,
	"./videoComment/ItemList.vue": 557,
	"./videoComment/ItemParticulars.vue": 261,
	"./videoData/ItemAudit.vue": 262,
	"./videoData/ItemList.vue": 558,
	"./videoData/ItemParticulars.vue": 263,
	"./videoTransmit/ItemAdd.vue": 264,
	"./videoTransmit/ItemEdit.vue": 265,
	"./videoTransmit/ItemList.vue": 559,
	"./videoTransmit/ItemParticulars.vue": 266
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1331;


//////////////////
// WEBPACK FOOTER
// ./src/views ^\.\/.*\.vue$
// module id = 1331
// module chunks = 1